export var ModalIds;
(function (ModalIds) {
    ModalIds["CONTACT"] = "CONTACT_FORM";
    ModalIds["PRICE"] = "SUGGEST_PRICE";
    ModalIds["MASONRY"] = "IMAGES_MASONRY";
    ModalIds["SLIDER"] = "IMAGES_FULLSCREEN";
    ModalIds["ENERGY"] = "ENERGY";
    ModalIds["MAP"] = "MAP_FULLSCREEN";
    ModalIds["FEATURES"] = "FEATURES";
    ModalIds["MEDIA"] = "MEDIA_FULLSCREEN";
})(ModalIds || (ModalIds = {}));
